import * as React from 'react';
import { Dialog } from '../dialog/Dialog';
import { DialogBody } from '../dialog/DialogBody';
import { Button } from '../button/Button';
import { LabelValue } from '../label-value/LabelValue';
import { useAppConfig } from '@mc/react-app-base';
import { Title } from '../typography/Title';
import { Space } from '../space/Space';
import { Text } from '../typography/Text';
import { Classes, ModalComponentProps } from '../index';

export type AboutProps = ModalComponentProps & {
  icon?: React.ReactNode;
};
export const About: React.FC<AboutProps> = ({ onClose, icon }) => {
  const appConfig = useAppConfig();
  return (
    <Dialog className={Classes.ABOUT_DIALOG}>
      <DialogBody>
        <div className={Classes.ABOUT_DIALOG_CONTAINER}>
          <Space className={'d-flex align-items-center'} size={'2'} vertical>
            <div>{icon}</div>
            <Title type={'card'}>{appConfig.applicationName}</Title>
            <Space className={'d-flex align-items-center'} vertical size={'1'}>
              <LabelValue lastItem horizontal label={'Verze'}>
                {appConfig?.version}
              </LabelValue>
              {appConfig?.applicationDescription && (
                <Text className={Classes.ABOUT_DIALOG_DESCRIPTION}>
                  {appConfig?.applicationDescription}
                </Text>
              )}
            </Space>
            <Text>Copyright © Marbes s.r.o.</Text>
            <Button style={'primary'} fill onClick={onClose} dataTest={'close'}>
              Zavřít
            </Button>
          </Space>
        </div>
      </DialogBody>
    </Dialog>
  );
};
